import { ControleEstoqueLocalStruct } from './controle-estoque-local.struct';

export class ControleEstoqueListStruct {
  idProduto: number;
  descricao: string;
  codigoSku?: string;
  gtinEan?: string;
  unidade?: string;
  localizacao?: string;
  quantidadeLocais: number = 0;
  saldoFisico: number = 0;
  saldoReservado: number = 0;
  saldoDisponivel: number = 0;
  custoMedio?: number;
  custoTotal?: number;
  preco?: number;
  isControlaLotes: boolean = false;
  isControlaSeries: boolean = false;
  locais: ControleEstoqueLocalStruct[] = [];
}
